import React from 'react';
import { Card, SectionTitle, NumberField, SelectField, Metric } from './components';
import { clp } from '../../utils/cotizadorEngine';

export default function VistaCliente({ quote, calc, updateQuote, updateDocumento }) {
  const totales = calc.totales || {};
  const montoFactura = totales.monto_factura ?? quote.monto_factura ?? 0;
  const montoOperacion = totales.monto_operacion ?? quote.monto_operacion ?? 0;
  const anticipoPct = montoFactura ? Math.round((montoOperacion / montoFactura) * 100) : 100;
  const docs = quote.documentos || [];
  const primerDoc = docs[0] || {};

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <Card>
        <SectionTitle title="Portal Cliente" subtitle="Simulación referencial (totales de la operación)." />
        <div className="space-y-4">
          <p className="text-sm text-slate-600">
            {totales.cantidad_documentos > 1
              ? `${totales.cantidad_documentos} facturas en esta cotización.`
              : 'Una factura en esta cotización.'}
          </p>
          {docs.length === 1 && (
            <>
              <NumberField
                label="Monto de la factura"
                value={primerDoc.monto_factura}
                onChange={(v) => {
                  updateDocumento(0, 'monto_factura', v);
                  updateDocumento(0, 'monto_operacion', v);
                }}
                prefix="$"
              />
              <NumberField label="Días hasta vencimiento" value={primerDoc.plazo} onChange={(v) => updateDocumento(0, 'plazo', v)} suffix="días" />
            </>
          )}
          <SelectField
            label="Tipo de cliente"
            value={quote.tipo_cliente}
            onChange={(v) => updateQuote('tipo_cliente', v)}
            options={[['Nuevo', 'Cliente nuevo'], ['Antiguo', 'Cliente antiguo'], ['Recurrente preferente', 'Cliente preferente']]}
          />
        </div>
      </Card>

      <Card>
        <SectionTitle title="Tu oferta referencial" subtitle="Valores sujetos a validación final." />
        <div className="grid gap-3">
          <Metric label="Monto factura total" value={clp(montoFactura)} />
          <Metric label={`Monto anticipado (${anticipoPct}%)`} value={clp(montoOperacion)} />
          <Metric label="Costo estimado" value={clp(calc.politica.ingreso_neto)} tone="orange" />
          <Metric label="Monto líquido estimado" value={clp(calc.politica.monto_liquido)} strong tone="green" />
        </div>
        <div className="mt-6 rounded-xl bg-blue-50 p-4 text-sm text-blue-900">
          La oferta es referencial. La validación final considera facturas, deudores, línea disponible y políticas internas.
        </div>
      </Card>
    </div>
  );
}
